import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  space: LocalisationResponse
}

const AdminPlanCard = ({ space }: Props) => {
  return (
    <MainContainer>
      <TopContainer>
        <Name numberOfLines={2} ellipsizeMode="tail">
          {space.libelle}
        </Name>
      </TopContainer>

      <BottomContainer>
        <Info numberOfLines={1} ellipsizeMode="tail">
          {space.code}
        </Info>
      </BottomContainer>
    </MainContainer>
  )
}

export default AdminPlanCard

const MainContainer = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `width: 360px;`}
  ${(props) => props.theme.constants.shadow};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.incident};
  overflow: hidden;
`

const TopContainer = styled(View)`
  padding: 16px 24px;
  height: 76px;
  background-color: ${(props) => props.theme.colors.background};
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Option};
`

const BottomContainer = styled(View)`
  padding: 16px 24px;
`
